import { useEffect, useState } from "react";
import { Checkbox } from "../../../components/Checkbox";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStep.module.scss";
import classNames from "classnames/bind";
import { InputSearch } from "shared/components/InputSearch";
const css = classNames.bind(styles);

export const BenefitUnits = ({ benefit, units, brands, onChange }) => {
  const [unitsSelected, setUnits] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (benefit?.units_valid)
      setUnits(benefit.units_valid.map((item) => item?.id || item));
  }, [benefit]);

  const addUnit = (unitId) => {
    if (unitsSelected.includes(unitId)) {
      onChange({
        ...benefit,
        units_valid: unitsSelected.filter((item) => item !== unitId),
      });

      return;
    }

    onChange({
      ...benefit,
      units_valid: [...unitsSelected, unitId],
    });
  };

  const [search, setSearch] = useState("");

  const filteredUnits = units.filter((unit) => {
    const searchLower = search.toLowerCase();
    return (
      unit.name.toLowerCase().includes(searchLower) &&
      (((benefit.brands_valid || []).length > 0 &&
        benefit.brands_valid.includes(unit.brand_id)) ||
        (brands || []).length === 1)
    );
  });

  return (
    <>
      <div className="d-flex align-center justify-between">
        <Label
          text="Em quais unidades o benefício poderá ser utilizado?"
          className="mb-0"
        />
        <div className="d-flex align-center">
          <Checkbox
            value={true}
            checked={unitsSelected.length === units.length}
            readOnly
          />
          <div className={styles.collapsible}>
            <div
              className={styles.chevron}
              onClick={() => setCollapsed(!collapsed)}
            >
              <i className="fas fa-chevron-down" />
            </div>

            <div
              className={css({
                collapsed: true,
                in: collapsed,
                out: !collapsed,
              })}
            >
              <ul className={styles.options}>
                <li
                  onClick={() => {
                    onChange({
                      ...benefit,
                      units_valid: units
                        .filter((item) => item.id)
                        .map((item) => item.id),
                    });
                    setCollapsed(false);
                  }}
                >
                  Selecionar tudo
                </li>
                <li
                  onClick={() => {
                    onChange({
                      ...benefit,
                      units_valid: [],
                    });
                    setCollapsed(false);
                  }}
                >
                  Desmarcar tudo
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <InputSearch
        placeholder="Buscar por unidade..."
        design="three"
        className="mt-20"
        occurrences={units.length}
        onChange={(e) => setSearch(e.target.value)}
      />
      <Hairline className="mt-15 mb-15" />
      {(filteredUnits || []).map((item) => {
        return (
          <Checkbox
            key={item.id}
            family="place"
            className="mt-10"
            value={true}
            checked={unitsSelected.includes(item.id)}
            onChange={() => addUnit(item.id)}
          >
            {item.brand_name} - {item.name}
          </Checkbox>
        );
      })}
    </>
  );
};
